<template>
  <div class="review-us">
    <div class="--title">
      {{ $i18nPresenter.t('review_us_get_free_month') }}
    </div>
    <div
      class="--content flex justify-between items-center"
      role="button"
      tabindex="0"
      @click="reviewUs"
      @keypress.enter="reviewUs"
    >
      <div class="--information-box flex gap-3">
        <aha-icon
          name="logo-g2"
          viewBox="0 0 41 41"
          maintain-color
          height="41"
          width="41"
        />
        <div>
          <div>
            <aha-icon
              v-for="index in 4"
              :key="index"
              name="star-full-v2"
              viewBox="0 0 17 17"
              class="star-color"
              height="16"
              width="16"
            />
            <aha-icon
              name="star-half-v2"
              viewBox="0 0 17 17"
              class="star-color"
              maintain-color
              height="16"
              width="16"
            />
          </div>
          <span class="--title">150+ {{ $i18nPresenter.t('reviews') }}</span>
        </div>
      </div>
      <aha-antd-button
        v-aha-emit-action
        name="review-us-button"
        variant="link"
      >
        {{ $i18nPresenter.t('see_how') }}
      </aha-antd-button>
    </div>
  </div>
</template>

<script>
const REVIEW_US_URL = 'https://ahaslides.com/blog/g2-software-reviews-guide/?utm_source=presenter_home&utm_medium=cta&utm_campaign=g2_review'

export default {
  name: 'ReviewUs',
  methods: {
    reviewUs() {
      window.open(REVIEW_US_URL, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.review-us {
  margin-bottom: 12px;
  .--title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .--content {
    border-radius: 8px;
    cursor: pointer;
    padding: 1rem;
    border: 1.5px solid theme('colors.gray.50');
  }
  .star-color {
    color: #FF492C;
  }
}
</style>
